import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CustomButton from "../CustomButton";

const ContactResultsList = ({
  onPlatform = [],
  invite = [],
  selectedIds,
  onToggle,
  onToggleAllInvite,
}) => {
  const inviteable = invite.filter(
    (c) => !c.invite_blocked && !c.already_invited_by_self
  );
  const allSelected =
    inviteable.length > 0 &&
    inviteable.every((c) => selectedIds.includes(c.id));

  return (
    <div className="gn-results">
      <div className="gn-results-col">
        <h5>Already on Workbrook ({onPlatform.length})</h5>
        <div className="gn-results-list">
          {onPlatform.length === 0 && (
            <p className="text-muted small p-2 mb-0">No matches found</p>
          )}
          {onPlatform.map((c) => (
            <div key={c.id} className="gn-contact-row">
              <img
                className="gn-contact-avatar"
                src={
                  c.profile?.image_url ||
                  "https://res.cloudinary.com/dllrkis3c/image/upload/v1592308594/default_avatar.png"
                }
                alt=""
              />
              <div className="gn-contact-info">
                <div className="name">
                  {c.profile?.first_name
                    ? `${c.profile.first_name} ${c.profile.last_name || ""}`
                    : c.name || c.email || c.phone}
                </div>
                <div className="email">{c.email || c.phone}</div>
              </div>
              <div className="gn-contact-actions">
                {c.matched_user_id && (
                  <Link to={`/profile/${c.matched_user_id}`}>
                    <CustomButton
                      text="Connect"
                      backgroundColor="#3A6ED4"
                      color="#fff"
                      additionalClass="btn-sm"
                    />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="gn-results-col">
        <h5>
          <label className="mb-0 d-flex align-items-center" style={{ gap: 8 }}>
            <input
              type="checkbox"
              checked={allSelected}
              onChange={() => onToggleAllInvite(!allSelected)}
              disabled={inviteable.length === 0}
            />
            Select to invite ({inviteable.length})
          </label>
        </h5>
        <p className="small text-muted px-2 mb-1">
          Check the people you want to invite. Nothing is sent yet.
        </p>
        <div className="gn-results-list">
          {invite.length === 0 && (
            <p className="text-muted small p-2 mb-0">No contacts to invite</p>
          )}
          {invite.map((c) => {
            const disabled = c.invite_blocked || c.already_invited_by_self;
            const contactLabel = c.email || c.phone || "";
            const viaSms = c.invite_channel === "sms" || (!c.email && !!c.phone);
            return (
              <div key={c.id} className="gn-contact-row">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(c.id)}
                  disabled={disabled}
                  onChange={() => onToggle(c.id)}
                />
                <div className="gn-contact-info">
                  <div className="name">{c.name || contactLabel}</div>
                  <div className="email">
                    {contactLabel}
                    {viaSms ? " · SMS" : c.email ? " · Email" : ""}
                  </div>
                  {c.invite_blocked && (
                    <div className="gn-blocked">
                      Already invited by someone else
                    </div>
                  )}
                  {c.already_invited_by_self && !c.invite_blocked && (
                    <div className="gn-blocked">Already invited</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

ContactResultsList.propTypes = {
  onPlatform: PropTypes.array,
  invite: PropTypes.array,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onToggleAllInvite: PropTypes.func.isRequired,
};

export default ContactResultsList;
